import React from 'react';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay - Elegant Pizza */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1574071318508-1cdbab80d002?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxpdGFsaWFuJTIwcGl6emF8ZW58MHx8fHwxNzYwMDg4MTEzfDA&ixlib=rb-4.1.0&q=85"
          alt="Italian Restaurant"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <div className="animate-fade-in-up">
          <p className="text-white/80 text-base md:text-lg font-light tracking-widest mb-4 uppercase">
            Welcome to
          </p>
          <h1 className="text-7xl md:text-9xl font-light text-white mb-8 tracking-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Pazzo
          </h1>
          <div className="w-24 h-px bg-white/60 mx-auto mb-8"></div>
          <p className="text-lg md:text-xl text-white/80 mb-16 font-light max-w-xl mx-auto leading-relaxed">
            Experience fine dining in the heart of Helsinki
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://www.restaurantlogin.com/api/fb/_x50aq"
              target="_blank"
              rel="noopener noreferrer"
              className="px-10 py-4 bg-white text-black font-normal tracking-wider uppercase text-sm hover:bg-zinc-200 transition-all duration-300"
            >
              View Menu & Order
            </a>
            <button
              onClick={() => document.getElementById('reservation')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-10 py-4 bg-transparent border border-white hover:bg-white hover:text-black text-white font-normal tracking-wider uppercase text-sm transition-all duration-300"
            >
              Book a Table
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/70 animate-bounce cursor-pointer"
      >
        <ChevronDown size={28} strokeWidth={1.5} />
      </button>
    </section>
  );
};

export default Hero;